package org.example.project.service

import androidx.compose.runtime.mutableStateMapOf
import org.example.project.utils.All

object CRChatPopupService {

    private val popupsByNode = mutableStateMapOf<String, List<All>>()

    fun getPopups(node: String): List<All> = popupsByNode[node] ?: emptyList()

    fun openPopup(node: String, art: String, cr: All) {
        if (node.isBlank() || art.isBlank() || cr.id.isBlank()) return
        val popup = cr.copy(
            key = "CRChatPopup",
            art = art,
            bereich = node,
            label = cr.crNummer.ifBlank { "CR-${cr.id}" }
        )
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()) + popup
    }

    fun closePopup(node: String, crId: String) {
        popupsByNode[node] = (popupsByNode[node] ?: emptyList()).filterNot { it.id == crId }
    }
}
